/**
 * Canonical `nivel_jerarquico` values (panel-segment-crud) — mirrors
 * `CanonicalHierarchyLevels.Values` (Services/Admin/CanonicalHierarchyLevels.cs), itself the
 * same literal set as Postgres's `ck_contact_nivel` CHECK constraint. Kept as one small,
 * feature-local list rather than fetched from the server: these five values are fixed by a
 * database CHECK constraint, not runtime configuration.
 */
export const HIERARCHY_LEVEL_OPTIONS: ReadonlyArray<{ readonly value: string; readonly label: string }> = [
  { value: "clevel", label: "C-Level" },
  { value: "director", label: "Director" },
  { value: "gerente", label: "Gerente" },
  { value: "coordinador", label: "Coordinador" },
  { value: "otro", label: "Otro" },
];
